






















































import { computed, defineComponent, watch } from '@vue/composition-api';
import SimpleCard from '@front-app/components/cards/SimpleCard.vue';
import { getLearningProgramsStore } from '@front-app/modules/learningPrograms/store/LearningProgramsStore';
import PaddedContent from '@front-app/components/layouts/columns/PaddedContent.vue';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import LoaderState from '@front-app/components/LoaderState.vue';
import { htmlToText } from '@front-app/util/content';
import { Location } from 'vue-router';
import { Routes } from '@front-app/constants/routes';
import LearningMeta from '@front-app/modules/learningPrograms/components/LearningMeta.vue';

export default defineComponent({
	components: {
		SimpleCard,
		PaddedContent,
		ErrorCard,
		LoaderState,
		LearningMeta,
	},
	props: {
		groupId: {
			type: String,
			required: true,
		},
	},
	setup(props) {
		const programsStore = getLearningProgramsStore();
		const {
			track: trackProgramsFetch,
			isLoading: isLoadingPrograms,
			isError: isErrorPrograms,
		} = useAsyncStatus();
		watch(() => props.groupId, () => {
			trackProgramsFetch(programsStore.fetchGroupPrograms(props.groupId, false));
		}, { immediate: true });
		const learningPrograms = computed(() => programsStore.getPublishedGroupPrograms(props.groupId));

		return {
			learningPrograms,
			isLoadingPrograms,
			isErrorPrograms,
			htmlToText,
			toProgram(programId: string): Location {
				return {
					name: Routes.GROUP_LEARNING_PROGRAM,
					params: { programId },
				};
			},
		};
	},
});
